// extracted by mini-css-extract-plugin
module.exports = {"title":"Header_title__YE1Jl","icon":"Header_icon__Xgg_T"};